import React, {createContext, useContext, useEffect, useState} from 'react';
import {HQ} from '../sportConfig';
import {TemporaryPortraitMark} from './PlayerPortrait';
import './LocalPlayerPortrait.css';

const Portraits = createContext({});
const keyFor = player => String(player.id || player.position_key || `${player.name}:${player.number}`);
const localImage = url => /^\/sportsim\/api\/(?:player-portraits\/image\/[a-f0-9]{64}|hockey\/player-profiles\/[1-9]\d*\/photo|player-portraits\/stored\/(?:floorball|football)\/[A-Za-z0-9_./%\-]+\?(?:t=[A-Za-z0-9_.-]{1,100}&)?v=[a-f0-9]{64})$/.test(url || '');

export function LocalPortraits({players = [], context = {}, children}) {
  const [images, setImages] = useState({});
  const [revision, setRevision] = useState(0);
  const request = JSON.stringify(players.map(player => ({
    id: String(player.id || ''), name: player.name || '', ...context,
    profile_path: player.squad_profile_url || player.profile_url || '',
  })));
  const keys = JSON.stringify(players.map(keyFor));
  useEffect(() => {
    const update = () => setRevision(value => value + 1);
    window.addEventListener('sports-hq-portrait-changed', update);
    return () => window.removeEventListener('sports-hq-portrait-changed', update);
  }, []);
  useEffect(() => {
    const controller = new AbortController();
    setImages({});
    const people = JSON.parse(request);
    if (!people.length) return undefined;
    fetch('/sportsim/api/player-portraits/local', {method: 'POST',
      headers: {'Content-Type': 'application/json'}, body: JSON.stringify({sport: HQ.sport, players: people}),
      signal: controller.signal, cache: 'no-store'})
      .then(response => response.ok ? response.json() : null)
      .then(data => {
        if (!controller.signal.aborted && Array.isArray(data?.portraits)) {
          const ids = JSON.parse(keys);
          setImages(Object.fromEntries(ids.map((id, index) => [id, data.portraits[index]])));
        }
      }).catch(() => {});
    return () => controller.abort();
  }, [request, keys, revision]);
  return <Portraits.Provider value={images}>{children}</Portraits.Provider>;
}

export default function LocalPlayerPortrait({player}) {
  const portrait = useContext(Portraits)[keyFor(player)];
  const url = localImage(portrait?.image_url) ? portrait.image_url : null;
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [url]);
  const initials = String(player.name || '').trim().split(/\s+/).filter(Boolean).map(word => word[0]).slice(0, 2).join('');
  return <span className="local-player-portrait" aria-hidden="true">
    {url && !failed ? <><img src={url} alt="" loading="lazy" decoding="async" onError={() => setFailed(true)}/>
      {portrait.overridden && <TemporaryPortraitMark/>}</>
      : <span className="local-player-portrait__fallback">{initials || (player.number ? `#${player.number}` : '–')}</span>}
  </span>;
}
